var dataset;
if ( typeof ProductVariants !== 'function' ) {

	class ProductVariants extends HTMLElement {

		constructor() {
			super();
			this.initialized = false;
			this.init();
		}

		init() {
			if (this.initialized) {
				return;
			}

			this.isHSFBundle = this.closest('.hsf-product-bundle') !== null;

			this.price = document.querySelector(`#product-price-${this.dataset.id}`);
			dataset = this.dataset;

			if ( this.price ) {
				this.priceOriginal = this.price.querySelector('[data-js-product-price-original]');
				this.priceCompare = this.price.querySelector('[data-js-product-price-compare]');
				this.priceUnit = this.price.querySelector('[data-js-product-price-unit]');
			}

			this.productForm = document.querySelector(`#product-form-${this.dataset.id}`);
			if ( this.productForm ) {
				this.productQty = this.productForm.querySelector('[data-js-product-quantity]');
				this.addToCart = this.productForm.querySelector('[data-js-product-add-to-cart]');
				this.addToCartText = this.productForm.querySelector('[data-js-product-add-to-cart-text]');
			}

			this.addEventListener('change', this.onVariantChange);
			let initVariantChange = false;

			if ( this.hasAttribute('data-variant-required' ) ) {
				this.variantRequired = true;
				this.noVariantSelectedYet = true;
				if ( document.location.search.includes('variant') ) {
					const initVariant = parseInt(new URLSearchParams(document.location.search).get('variant'));
					this.currentVariant = this.getVariantData().find((variant) => {
						if ( variant.id == initVariant ) {
							variant.options.map((option, index) => {
								const variantContainer = this.querySelectorAll(`[data-js-product-variant]`)[index].querySelector(`[data-js-product-variant-container]`);
								if ( variantContainer.dataset.jsProductVariantContainer == 'radio' ) {
									variantContainer.querySelector(`input[value="${option}"]`).checked = true;
								} else if ( variantContainer.dataset.jsProductVariantContainer == 'select' ) {
									variantContainer.value = option;
								}
							})
							return variant;
						}
					});

					if ( this.currentVariant ) {
						this.variantRequired = false;
						this.noVariantSelectedYet = false;
						initVariantChange = true;
					}

				}

			} else {
				this.variantRequired = false;
				this.noVariantSelectedYet = false;
			}

			this.updateOptions();
			this.updateMasterId();
			this.updateUnavailableVariants();

			this.productStock = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity]`);
			this.productStockProgress = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-progress]`);
			if ( this.productStock && document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`) ) {
				this.productStockData = JSON.parse(document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`).dataset.inventory);
			}
			this.updateStock();

			this._event = new Event('VARIANT_CHANGE');

			if ( initVariantChange ) {
				this.onVariantChange();
			}
			this.onVariantChange();

			this.initialized = true;
		}

		connectedCallback() {
			if (!this.initialized) {
				this.init();
			}
		}

		onVariantChange(){
			this.updateOptions();
			this.updateMasterId();
			this.updateVariantInput();
			if ( this.price ) {
				this.updatePrice();
			}
			this.updateStock();
			this.updateUnavailableVariants();
			this.updatePickupAvailability();
			if ( ! this.hasAttribute('data-no-history') && !Shopify.designMode ) {
				this.updateURL();
			}
			this.updateTotalMonthly();
			this.updateDetails();
			if (document.querySelector(".alert")) {
				document.querySelector(".alert").remove();
			}

			const product_variants = JSON.parse(document.querySelector('#productVariants').textContent.replace("\n", ""));

			for (var variant of product_variants) {
				for (var key in variant) {
					if (key == this.currentVariant?.id) {
						//checking if selected variant is installment and getting associated original product to do out of stock validations
						const isInstallment = this.currentVariant?.sku?.split("_")[0] == "inst";
						if (isInstallment) {
							const variantInfo = JSON.parse(document.querySelector("#variantInfo").textContent.replace("\n", ""));
							for (var product of variantInfo) {
								if (product.sku == this.currentVariant?.sku?.split("_")[1]) {
									//checking if installment associated product has prekit info and calling renderProductInfo()
									if (product.prekitInfo != "") {
										this.renderProductInfo(product.id);
									} else {
										if (this.productForm) {
											//checking if associated original product of installment is OOS and disabling ADD TO CART button
											if (!product.available) {
												if (this.productQty)
													this.productQty.style.display = "none";
												this.addToCart.classList.add("disabled");
												this.productForm.classList.add("disabled-cart");
												this.addToCartText.textContent =
													KROWN.settings.locales.products_sold_out_variant;
											} else {
												if (this.productQty) this.productQty.style.display = "";
												this.addToCart.classList.remove("disabled");
												this.productForm.classList.remove("disabled-cart");
												this.addToCartText.textContent = this.hasAttribute("data-show-bundle-wording")
													? KROWN.settings.locales.products_add_to_bundle_button
													: this.addToCartText.hasAttribute("data-show-preorder-wording")
														? KROWN.settings.locales.products_preorder_button
														: KROWN.settings.locales.products_add_to_cart_button;
											}
											// update add to cart button for PDP
											if (document.querySelector('product-page[id^="product"]')) {
												createCustomAddToCartBtnInPDP();
											}
										}
									}
								}
							}
							} else {
						    if (variant[key]) {
							    this.renderProductInfo(this.currentVariant.id);
						    }
						    else {
							if (this.productForm) {
								const variantSelectContainer = this.querySelector('[data-js-product-variant-container="select"]');
								const linkedSkuAvailable = variantSelectContainer?.selectedOptions?.[0]?.dataset?.linked_skuAvailable;
								if (!this.currentVariant || !this.currentVariant.available || linkedSkuAvailable === "false") {
									if (this.productQty) this.productQty.style.display = "none";
									this.addToCart.classList.add("disabled");
									this.productForm.classList.add("disabled-cart");
									this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
								}
								else {
									if (this.productQty) this.productQty.style.display = "";
									this.addToCart.classList.remove("disabled");
									this.productForm.classList.remove("disabled-cart");
									this.addToCartText.textContent = this.hasAttribute("data-show-bundle-wording")
										? KROWN.settings.locales.products_add_to_bundle_button
										: this.addToCartText.hasAttribute("data-show-preorder-wording")
										? KROWN.settings.locales.products_preorder_button
										: KROWN.settings.locales.products_add_to_cart_button;
								}

								if (!this.currentVariant) {
									this.productForm.classList.add("unavailable-variant");
									this.addToCartText.textContent = this.variantRequired && this.noVariantSelectedYet
										? KROWN.settings.locales.products_variant_required
										: KROWN.settings.locales.products_unavailable_variant;
								}
								else {
									this.productForm.classList.remove("unavailable-variant");
								}

								// update add to cart button for PDP
								if (document.querySelector('product-page[id^="product"]')) {
									createCustomAddToCartBtnInPDP();
							}
							}
						}

						// update add to cart button for PDP
						if (document.querySelector('product-page[id^="product"]')) {
							createCustomAddToCartBtnInPDP();
						}
					}
					}
				}
			}

			this.dispatchEvent(this._event);

			// renaming the dummy variant to show the original sku
			document.querySelectorAll(".product-variant-select option").forEach(option => {
				option.innerText = option.innerText.split("-installment")[0];
			});

			if (this.querySelector(".selected_subscription_option") && this.querySelector('.selected_subscription_option').innerHTML !== "") {
				this.querySelector('.selected_subscription_option').innerHTML = this.querySelector('.selected_subscription_option').innerHTML.split("-installment")[0];
			}
		}

		updateTotalMonthly() {
			const payPerMonthTotalling = document.getElementById("monthly-total-price");
			const payPerMonthTotallingPPM = document.getElementById("monthly-total-price-ppm");
			const showPolandSpecificMsg = document.getElementById("show_seperate_poland_msg")?.value;
			const seperateInstallmentFeesText = document.getElementById("seperate-installment-fees-text");	
			const selectedOption = Array.from(document.querySelectorAll(".product-variant-select option")).find(option => option.selected);
			const monthlyValTotal = selectedOption?.getAttribute('data-total-monthly-val');
			const monthlyValTotalRaw = selectedOption?.getAttribute('data-total-monthly-val-raw') || monthlyValTotal;
			if (showPolandSpecificMsg == "true") {
				const isSubscription = document.querySelector(".type_of_subscription")?.checked;
				const isInstallment = this.currentVariant?.sku?.split("_")[0] == "inst";
				if (isSubscription != "" && monthlyValTotal) {
					if (isInstallment) {
						seperateInstallmentFeesText.classList.remove("display-none");
						payPerMonthTotalling.classList.remove("display-none");
						payPerMonthTotalling.querySelector("#totalMonthlyVal").innerHTML =  monthlyValTotal;
						payPerMonthTotallingPPM.classList.add("display-none");
						document.getElementById("monthly_total_base_price").disabled = false;
						// Ensure monthlyValTotalRaw always has two decimals
						let formattedMonthlyValTotalRaw = monthlyValTotalRaw;
						if (typeof monthlyValTotalRaw === 'string' && monthlyValTotalRaw.match(/^\d+\.?\d*$/)) {
							const num = Number(monthlyValTotalRaw);
							if (!isNaN(num)) {
								formattedMonthlyValTotalRaw = num.toFixed(2);
							}
						}
						document.getElementById("monthly_total_base_price").value = formattedMonthlyValTotalRaw;
					} else {
						seperateInstallmentFeesText.classList.add("display-none");
						payPerMonthTotallingPPM.classList.remove("display-none");
						payPerMonthTotalling.classList.add("display-none");
						payPerMonthTotallingPPM.querySelector("#totalMonthlyValPPM").innerHTML = monthlyValTotal;
						document.getElementById("monthly_total_base_price").disabled = false;
						document.getElementById("monthly_total_base_price").value = "";
					}
				} else {
				  seperateInstallmentFeesText.classList.add("display-none");
				  payPerMonthTotalling.classList.add("display-none");
				  payPerMonthTotallingPPM.classList.add("display-none");
				  document.getElementById("monthly_total_base_price").disabled = true;
				  document.getElementById("monthly_total_base_price").value = "";
				}
			} else {
				if (monthlyValTotal) {
				  payPerMonthTotalling.classList.remove('display-none');
				  document.getElementById("monthly_total_base_price").disabled = false;
				  // Ensure monthlyValTotalRaw always has two decimals
				  let formattedMonthlyValTotalRaw = monthlyValTotalRaw;
				  if (typeof monthlyValTotalRaw === 'string' && monthlyValTotalRaw.match(/^\d+\.?\d*$/)) {
					const num = Number(monthlyValTotalRaw);
					if (!isNaN(num)) {
						formattedMonthlyValTotalRaw = num.toFixed(2);
					}
				  }
				  document.getElementById("monthly_total_base_price").value =
					formattedMonthlyValTotalRaw;
				  payPerMonthTotalling.querySelector("#totalMonthlyVal").innerHTML =
					monthlyValTotal;
				} else {
				  payPerMonthTotalling.classList.add("display-none");
				  document.getElementById("monthly_total_base_price").disabled = true;
				  document.getElementById("monthly_total_base_price").value = "";
				}
			}
		}

		// function to validate inventory/quantity of prekit products which are configured for a product/variant
		renderProductInfo(requestedVariantId) {
			const sectionId = this.dataset.id;
			const addtocart = document.getElementById("addToCartButton-" + sectionId);
			let url = `${this.dataset.url}?view=inventory-check`;
			if (addtocart.hasAttribute("data-has-variant")) {
				url = `${this.dataset.url}?variant=${requestedVariantId}&view=inventory-check`;
			}
			fetch(url)
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					return response.text(); // Assuming plain text
				})
				.then((itemData) => {
					const isSoldOut = itemData.split("|")[0].trim() === "true";
					addtocart.classList.toggle("disabled", isSoldOut);
					this.addToCartText.textContent = isSoldOut ? KROWN.settings.locales.products_sold_out_variant : this.isHSFBundle ? KROWN.settings.locales.products_add_product_to_bundle : KROWN.settings.locales.products_add_to_cart_button;
				})
				.then(() => {
					// update add to cart button for PDP
					if (document.querySelector('product-page[id^="product"]')) {
						createCustomAddToCartBtnInPDP();
					}
				})
				.catch((error) => {
					console.error("Error fetching stock data:", error); // Handle error gracefully, e.g., display an error message to the user
				});
		}

		updateOptions(){

			this.options = [];

			this.querySelectorAll('[data-js-product-variant-container]').forEach(elm=>{
				if ( elm.dataset.jsProductVariantContainer == 'radio' ) {
					elm.querySelectorAll('.product-variant__input').forEach(el=>{
						if ( el.checked ) {
							this.options.push(el.value);
						}
					});
				} else {
					if ( ! ( this.variantRequired && elm.selectedIndex == 0 ) ) {
						this.options.push(elm.value);
					}
				}
			});

			if ( this.variantRequired && this.noVariantSelectedYet && this.options.length >= parseInt(this.dataset.variants) ) {
				this.noVariantSelectedYet = false;
			}

		}

		updateMasterId(){
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options.map((option, index) => {
					return this.options[index] === option;
				}).includes(false);
			});
		}

		updatePrice(){
			if (!this.currentVariant) {
				if ( ! ( this.variantRequired && this.noVariantSelectedYet ) ) {
					this.priceOriginal.innerHTML = '';
					this.priceCompare.innerHTML = '';
					this.priceUnit.innerHTML = '';
				}
			} else {
				this.priceOriginal.innerHTML = _formatMoney(this.currentVariant.price, KROWN.settings.shop_money_format);
				if ( this.currentVariant.compare_at_price > this.currentVariant.price ) {
					this.priceCompare.innerHTML = _formatMoney(this.currentVariant.compare_at_price, KROWN.settings.shop_money_format);
				} else {
					this.priceCompare.innerHTML = '';
				}

				if ( this.currentVariant.unit_price_measurement ) {
					this.priceUnit.innerHTML = `
						${_formatMoney(this.currentVariant.unit_price, KROWN.settings.shop_money_format)} /
						${( this.currentVariant.unit_price_measurement.reference_value != 1 ? this.currentVariant.unit_price_measurement.reference_value + ' ' : '' )}
						${this.currentVariant.unit_price_measurement.reference_unit}
					`;
				} else {
					this.priceUnit.innerHTML = '';
				}
			}

		}

      updatePriceWithTax(taxPercentage){
			if (!this.currentVariant) {
				if ( ! ( this.variantRequired && this.noVariantSelectedYet ) ) {
					this.priceOriginal.innerHTML = '';
					this.priceCompare.innerHTML = '';
					this.priceUnit.innerHTML = '';
				}
			} else {
				let oldPrice = this.currentVariant.price;
				oldPrice += oldPrice * (taxPercentage / 100);
				
				this.priceOriginal.innerHTML = _formatMoney(oldPrice, KROWN.settings.shop_money_format);
				if ( this.currentVariant.compare_at_price > this.currentVariant.price ) {
					let compareAtPrice = this.currentVariant.compare_at_price;
					compareAtPrice += compareAtPrice * (taxPercentage / 100);
					this.priceCompare.innerHTML = _formatMoney(compareAtPrice, KROWN.settings.shop_money_format);
				} else {
					this.priceCompare.innerHTML = '';
				}

				if ( this.currentVariant.unit_price_measurement ) {
					let unitPrice = this.currentVariant.unit_price;
					unitPrice += unitPrice * (taxPercentage / 100);
					this.priceUnit.innerHTML = `
						${_formatMoney(unitPrice, KROWN.settings.shop_money_format)} /
						${( this.currentVariant.unit_price_measurement.reference_value != 1 ? this.currentVariant.unit_price_measurement.reference_value + ' ' : '' )}
						${this.currentVariant.unit_price_measurement.reference_unit}
					`;
				} else {
					this.priceUnit.innerHTML = '';
				}
			}

		}
      
		updateStock(){

			if (!this.currentVariant) {
				if ( this.productStock ) {
					this.productStock.innerHTML = '';
				}
			} else {
				if ( this.productStock && this.productStockData ) {

					let currentVariant = false;
					for ( const variant of this.productStockData ) {
						if ( variant.id == this.currentVariant.id ) {
							currentVariant = variant;
							break;
						}
					}
					this.productStock.innerHTML = '';

					if ( currentVariant ) {

						if ( currentVariant.quantity <= 0 ) {
							if ( currentVariant.inventory == 'continue' ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_preorder;
								this.productStock.setAttribute('data-stock', 'pre-order');
							} else if ( currentVariant.inventory == 'deny' ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
								this.productStock.setAttribute('data-stock', 'out-of-stock');
							}
						} else if ( currentVariant.quantity == '1' ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_one_product;
							this.productStock.setAttribute('data-stock', 'one-item-stock');
						} else if ( currentVariant.quantity <= parseInt(this.productStock.dataset.lowStock) ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace('{{ count }}', currentVariant.quantity);
							this.productStock.setAttribute('data-stock', 'little-stock');
						} else if ( currentVariant.unavailable ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
							this.productStock.setAttribute('data-stock', 'out-of-stock');
						} else if ( currentVariant.quantity > parseInt(this.productStock.dataset.lowStock) && this.productStock.dataset.type == "always" ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_many_products.replace('{{ count }}', currentVariant.quantity);
							this.productStock.setAttribute('data-stock', 'in-stock');
						} else if ( ! currentVariant.quantity && this.productStock.dataset.type == "always" ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_enough_products;
							this.productStock.setAttribute('data-stock', 'in-stock');
						}

						if ( this.productStockProgress ) {
							let progressQty = 0;
							if ( currentVariant.quantity <= 0 && currentVariant.inventory == 'continue' || typeof currentVariant.quantity === 'undefined' ) {
								progressQty = parseInt(this.productStock.dataset.highStock);
							} else if ( currentVariant.quantity > 0 ) {
								progressQty = currentVariant.quantity;
							}
							if ( progressQty >= parseInt(this.productStock.dataset.highStock) ) {
								this.productStockProgress.style.width = `100%`;
							} else {
								this.productStockProgress.style.width = `${100 * progressQty / parseInt(this.productStock.dataset.highStock)}%`;
							}
						}

					}
				}
			}
		}

		updateDetails(){

			document.querySelectorAll(`#product-${this.dataset.id} [data-js-product-sku]`).forEach(elm=>{
				if ( this.currentVariant && this.currentVariant.sku ) {
					elm.innerHTML = KROWN.settings.locales.product_sku + this.currentVariant.sku;
				} else {
					elm.innerHTML = '';
				}
			});

			document.querySelectorAll(`#product-${this.dataset.id} [data-js-product-barcode]`).forEach(elm=>{
				if ( this.currentVariant && this.currentVariant.barcode ) {
					elm.innerHTML = KROWN.settings.locales.product_barcode + this.currentVariant.barcode;
				} else {
					elm.innerHTML = '';
				}
			});

		}

		updatePickupAvailability() {
			const pickUpAvailability = document.querySelector('pickup-availability');
			if (!pickUpAvailability) return;

			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id);
			} else {
				pickUpAvailability.removeAttribute('available');
				pickUpAvailability.innerHTML = '';
			}
		}

		updateUnavailableVariants(){

			if ( this.dataset.hideVariants != 'false' ) {

				let options1 = {},
						options2 = {},
						options3 = {},

						option1Selected = null,
						option2Selected = null;

				if ( this.dataset.variants > 1 ) {
					option1Selected = this._getSelectedOption(0);
					this._resetDisabledOption(1);
				}
				if ( this.dataset.variants > 2 ) {
					option2Selected = this._getSelectedOption(1);
					this._resetDisabledOption(2);
				}

				this.getVariantData().forEach((el) => {
					if ( this.dataset.variants > 0 ) {
						if ( ! options1[el.option1] ) {
							options1[el.option1] = [];
						}
						options1[el.option1].push(String(el.available));
					}
					if ( this.dataset.variants > 1 ) {
						if ( ! options2[el.option2] ) {
							options2[el.option2] = [];
						}
						options2[el.option2].push(String(el.available));
					}
					if ( this.dataset.variants == 2 ) {
						if ( el.option1 == option1Selected && ! el.available ) {
							this._setDisabledOption(1, el.option2);
						}
					}
					if ( this.dataset.variants > 2 ) {
						if ( ! options3[el.option3] ) {
							options3[el.option3] = [];
						}
						options3[el.option3].push(String(el.available));
						if ( el.option2 == option2Selected && el.option1 == option1Selected && ! el.available ) {
							this._setDisabledOption(2, el.option3);
						}
					}

				});

				if ( this.dataset.variants > 0 ) {
					Object.keys(options1).forEach((key)=>{
						if ( ! options1[key].includes('true') ){
							this._setDisabledOption(0, key);
						}
					});
				}
				if ( this.dataset.variants > 1 ) {
					Object.keys(options2).forEach((key)=>{
						if ( ! options2[key].includes('true') ){
							this._setDisabledOption(1, key);
						}
					});
				}
				if ( this.dataset.variants > 2 ) {
					Object.keys(options3).forEach((key)=>{
						if ( ! options3[key].includes('true') ){
							this._setDisabledOption(2, key);
						}
					});
					Object.keys(options2).forEach((key)=>{
						if ( ! options2[key].includes('true') ){
							if ( option2Selected == key ) {
								if ( this.dataset.hideVariants == 'disable' ) {
									this.querySelectorAll('[data-js-product-variant]')[2].querySelector('.product-variant-value').setAttribute('disabled', 'disabled');
								} else {
									this.querySelectorAll('[data-js-product-variant]')[2].querySelector('.product-variant-value').classList.add('disabled');
								}
							}
						}
					});
				}

			}
		}

		_getSelectedOption(i){
			let selectedOption = null;
			this.querySelectorAll('[data-js-product-variant]')[i].querySelectorAll('[data-js-product-variant-container]').forEach(elm=>{
				if ( elm.dataset.jsProductVariantContainer == 'radio' ) {
					elm.querySelectorAll('.product-variant__input').forEach(el=>{
						if ( el.checked ) {
							selectedOption = el.value;
						}
					});
				} else {
					selectedOption = elm.value;
				}
			});
			return selectedOption;
		}

		_resetDisabledOption(i){
			this.querySelectorAll('[data-js-product-variant]')[i].querySelectorAll('.product-variant-value').forEach((elm)=>{
				elm.classList.remove('disabled');
				elm.classList.remove('hide-variant')
				if ( ! elm.hasAttribute('default') ) {
					elm.removeAttribute('disabled');
				}
				elm.parentNode.classList.remove('hide-variant');
			})
		}

		_setDisabledOption(i,option){
			let variant = this.querySelectorAll('[data-js-product-variant]')[i].querySelector(`.product-variant-value[value="${option.replace('"', '&x22;')}"]`);
			if ( variant ) {
				if ( this.dataset.hideVariants == 'disable' ) {
					variant.setAttribute('disabled', 'disabled');
				} else if ( this.dataset.hideVariants == 'true' ) {
					variant.classList.add('disabled');
				} else if ( this.dataset.hideVariants == 'hide' ) {
					if ( this.querySelectorAll('[data-js-product-variant]')[i].querySelector('[data-js-product-variant-container]').dataset.jsProductVariantContainer == 'radio' ) {
						variant.parentNode.classList.add('hide-variant');
					} else {
						variant.classList.add('hide-variant');
					}
				}
			}
		}

		updateURL(){
			if (!this.currentVariant) return;
			const searchParams = new URLSearchParams(window.location.search)
			searchParams.set('variant', this.currentVariant.id)
			window.history.replaceState({ }, '', `${this.dataset.url}?${searchParams.toString()}`);
		}

		updateVariantInput() {
			if (!this.currentVariant) return;
			const productForms = document.querySelectorAll(`#product-form-${this.dataset.id}, #product-form-installment`);
			productForms.forEach((productForm) => {
				const input = productForm.querySelector('input[name="id"]');
				input.value = this.currentVariant.id;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			});
		}

		getVariantData() {
			this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
			return this.variantData;
		}

	}

	if ( typeof customElements.get('product-variants') == 'undefined' ) {
		customElements.define('product-variants', ProductVariants);
	}

}

/* ---
	Product Form
--- */

if ( typeof ProductForm !== 'function' ) {

	class ProductForm extends HTMLElement {
		constructor() {
			super();
			this.initialized = false;
			this.init();
		}

		init(){
			if (this.initialized) {
				return;
			}

			this.cartType = this.hasAttribute('data-ajax-cart') ? 'ajax' : 'page';
			if ( ! document.body.classList.contains('template-cart') || this.hasAttribute('data-force-form' ) ) {
				this.form = this.querySelector('form');
				if (this.form) {
					this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
					this.ADD_TO_CART = new Event('add-to-cart');
				} else {
					console.warn('ProductForm: form element not found during initialization');
					return;
				}
			}
			if ( document.body.classList.contains('touchevents') ) {
				const submitButton = this.querySelector('[type="submit"]');
				if ( submitButton ) {
					submitButton.addEventListener('touchend', e=>{
						//submitButton.click();
					});
				}
			}

			this.initialized = true;
		}

		connectedCallback() {
			if (!this.initialized) {
				this.init();
			}
		}

		// add condition here using should_move_payment_method_to_checkout
		manualPaymentUpdate(variantID, paymentMethod) {
			if (paymentMethod) {
				const isManualPayment = KROWN.settings.manualPaymentTypes.includes(paymentMethod);
				if (isManualPayment) {
					const isSubscription = document.getElementById("selling_plan_selection");
					const sellingPlanId = isSubscription.value;
					const subscriptionName = document.getElementById("selling_plan_name");

					if (isSubscription.value != "") {
						isSubscription.value = "";
						document.getElementById("selling_plan_properties").value = sellingPlanId;
						document.getElementById("selling_plan_name").value = subscriptionName.value;
					}
				}
			}
			const variantInfo = JSON.parse(
					document.querySelector("#variantInfo").textContent.replace("\n", "")
				  );
			for (let variant of variantInfo) {
				if (variant.id == variantID) {
				  document.getElementById("discount_value").value = variant.discountValue;
				  break;
				}
			}
		}

		onSubmitHandler(e) {

			e.preventDefault();
			let paymentMethod = null;
			// Check cart payment method
			if (
        window?.cartDataForPaymentSelectionInCart &&
        window?.cartDataForPaymentSelectionInCart?.attributes
      ) {
        paymentMethod =
          window.cartDataForPaymentSelectionInCart.attributes?._paymentMethod;
      }
			let body = this._serializeForm(this.form);
			const urlParams = new URLSearchParams(body);
			const variantID = urlParams.get("id");
			this.manualPaymentUpdate(variantID, paymentMethod);
			body = this._serializeForm(this.form);
			if (variantID && typeof window.getVariantGlobalIdForCart === 'function') {
				const sep = body.length ? '&' : '';
				body +=
					sep +
					'properties[_globalId]=' +
					encodeURIComponent(window.getVariantGlobalIdForCart(variantID));
			}
	
			// Add _paymentMethod attribute to cart
			if (paymentMethod) {
				body += "&attributes[_paymentMethod]=" + paymentMethod;
			} 
			
			const submitButton = this.querySelector('[type="submit"]');

			this._setSubmittingState(submitButton, true);
			let alert = '';
			//added code to check if a product is restricted for add to cart and disabling it
			if (this.offsetParent.getAttribute("data-restrict_add_to_cart") === "true") {
				alert = document.createElement("span");
				alert.className = "alert alert--error hsf";
				alert.innerHTML = KROWN.settings.restrict_add_to_cart_error_msg;
				this.form.parentElement.append(alert);
				this._setSubmittingState(submitButton, false);
				return true;
			  }
			if (this.offsetParent.getAttribute('data-hsf_child') === 'true') {
				var element = document.querySelector(".alert--error.hsf");
				if (element) element.parentNode.removeChild(element);
				alert = document.createElement('span');
				alert.className = 'alert alert--error hsf';
				alert.innerHTML = KROWN.settings.hsf.hsf_unauthorized_add_to_cart;
				this.form.parentElement.append(alert);
				this._setSubmittingState(submitButton, false);
				return true;
			}
			let selectedQuantity = urlParams.get("quantity");
			const product_variants = JSON.parse(document.querySelector("#productVariants").textContent.replace("\n", ""));

			const cartItems = document.querySelectorAll(".cart__items > div");
			cartItems.forEach((ele) => {
				const productID = ele.dataset.id;
				if (productID.split(":")[0] == variantID) {
					selectedQuantity =
						parseInt(selectedQuantity) + parseInt(ele.dataset.qty);
				}
			});

			let hasPrekit = false;
			for (var variant of product_variants) {
				for (var key in variant) {
					if (key == variantID && variant[key]) {
						hasPrekit = true;
					}
				}
			}
			if (hasPrekit) {
				const datasetURL = dataset.url;
				const addtocart = document.getElementById(
					"addToCartButton-" + dataset.id
				);
				let url = `${datasetURL}?view=inventory-check`;
				if (addtocart.hasAttribute("data-has-variant")) {
					url = `${datasetURL}?variant=${variantID}&view=inventory-check`;
				}
				fetch(url)
					.then((response) => {
						if (!response.ok) {
							throw new Error(`HTTP error! status: ${response.status}`);
						}
						return response.text(); // Assuming plain text
					})
					.then((itemData) => {
						const prekit_data = itemData.trim().split("|");
						const prekitObj = JSON.parse(prekit_data[1]);
						let minqty = prekitObj[0]?.inventory / prekitObj[0]?.quantity;
						let addToCart = true;

						for (var prekit of prekitObj) {
							let quantity = prekit["quantity"];
							let inventory = prekit["inventory"];
							if (minqty > inventory / quantity) {
								minqty = inventory / quantity;
							}
							if (quantity * selectedQuantity > parseInt(inventory)) {
								addToCart = false;
								break;
							}
						}
						if (addToCart) {
							fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
								body,
								headers: {
									"Content-Type": "application/x-www-form-urlencoded",
									"X-Requested-With": "XMLHttpRequest",
								},
								method: "POST",
							})
								.then((response) => response.json())
								.then((response) => {
									if (response.status == 422) {
										// wrong stock logic alert
										alert = document.createElement("span");
										alert.className = "alert alert--error";
										if (typeof response.description === "string") {
											alert.innerHTML = response.description;
										} else {
											alert.innerHTML = response.message;
										}
										if (this.cartType == "page") {
											if (
												document.getElementById(
													"product-page-form-error-cart-alert"
												)
											) {
												document
													.getElementById(
														"product-page-form-error-cart-alert"
													)
													.remove();
											}
											alert.style.marginTop = "1em";
											alert.style.marginBottom = "0";
											alert.id = "product-page-form-error-cart-alert";
											this.form.parentElement.append(alert);
											return false;
										}
										return fetch("?section_id=helper-cart");
									} else {
										if (this.cartType == "page") {
											document.location.href = KROWN.settings.routes.cart_url;
											return false;
										} else {
											return fetch("?section_id=helper-cart");
										}
									}
								})
								.then((response) => response.text())
								.then((text) => {
									const sectionInnerHTML = new DOMParser().parseFromString(
										text,
										"text/html"
									);
									const cartFormInnerHTML =
										sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
									const cartSubtotalInnerHTML =
										sectionInnerHTML.getElementById(
											"AjaxCartSubtotal"
										).innerHTML;

									const cartItems = document.getElementById("AjaxCartForm");
									cartItems.innerHTML = cartFormInnerHTML;
									cartItems.ajaxifyCartItems();
									cartItems.initializeSubscriptionDetails();

									if (alert != "") {
										document
											.getElementById("AjaxCartForm")
											.querySelector("form")
											.prepend(alert);
									}

									document.getElementById("AjaxCartSubtotal").innerHTML =
										cartSubtotalInnerHTML;

									document
										.querySelectorAll("[data-header-cart-count]")
										.forEach((elm) => {
											elm.textContent = document.querySelector(
												"#AjaxCartForm [data-cart-count]"
											).textContent;
										});
									document
										.querySelectorAll("[data-header-cart-total")
										.forEach((elm) => {
											elm.textContent = document.querySelector(
												"#AjaxCartForm [data-cart-total]"
											).textContent;
										});
									this.dispatchEvent(this.ADD_TO_CART);

									// Add refreshCartPaymentMethods call
									if (typeof window.refreshCartPaymentMethods === 'function') {
									setTimeout(() => {
										window.refreshCartPaymentMethods();
									}, 100);
									}

									// a11y
									if (document.getElementById("screen-reader-info")) {
										document.getElementById(
											"screen-reader-info"
										).innerText = `${KROWN.settings.locales.cart_announcement}`;
										setTimeout(() => {
											document.getElementById(
												"screen-reader-info"
											).innerText = "";
										}, 1000);
									}
								})
								.catch((e) => {
									console.log(e);
								})
								.finally(() => {
									this._setSubmittingState(submitButton, false);
								});
						} else {
							if (document.querySelector(".alert")) {
								document.querySelector(".alert").remove();
							}
							alert = document.createElement("span");
							alert.className = "alert alert--error";
							var errormsg = KROWN.settings.prekit.prekit_out_of_stock;
							alert.innerHTML = errormsg.replace("minqty", minqty);
							this.form.parentElement.append(alert);
							this._setSubmittingState(submitButton, false);
						}
					})
					.catch((error) => {
						console.error("Error fetching stock data:", error); // Handle error gracefully, e.g., display an error message to the user
					});
			} else {
				fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
					body,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'X-Requested-With': 'XMLHttpRequest'
					},
					method: 'POST'
				})
					.then(response => response.json())
					.then(response => {
						if ( response.status == 422 ) {
							// wrong stock logic alert
							alert = document.createElement('span');
							alert.className = 'alert alert--error';
							if ( typeof response.description === 'string' ) {
								alert.innerHTML = response.description;
							} else {
								alert.innerHTML = response.message;
							}
							if ( this.cartType == 'page' ) {
								if ( document.getElementById('product-page-form-error-cart-alert') ) {
									document.getElementById('product-page-form-error-cart-alert').remove();
								}
								alert.style.marginTop = '1em';
								alert.style.marginBottom = '0';
								alert.id = 'product-page-form-error-cart-alert';
								this.form.parentElement.append(alert);
								return false;
							}
							return fetch('?section_id=helper-cart');
						} else {
							if ( this.cartType == 'page' ) {
								document.location.href = KROWN.settings.routes.cart_url;
								return false;
							} else {
								return fetch('?section_id=helper-cart');
							}
						}
					})
					.then(response => response.text())
					.then(text => {

						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

						const cartItems = document.getElementById('AjaxCartForm');
						cartItems.innerHTML = cartFormInnerHTML;
						cartItems.ajaxifyCartItems();
						cartItems.initializeSubscriptionDetails();


						if ( alert != '' ) {
							document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
						}

						document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});
						this.dispatchEvent(this.ADD_TO_CART);

						// Add refreshCartPaymentMethods call
						if (typeof window.refreshCartPaymentMethods === 'function') {
						setTimeout(() => {
							window.refreshCartPaymentMethods();
						}, 100);
						}

						// a11y
						if ( document.getElementById('screen-reader-info') ) {
							document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
							setTimeout(()=>{
								document.getElementById('screen-reader-info').innerText = '';
							}, 1000);
						}

					})
					.catch(e => {
						console.log(e);
					})
					.finally(() => {
						this._setSubmittingState(submitButton, false);
					});
			}
		}
		_setSubmittingState(button, isSubmitting) {
			if (!button) return;
			button.classList.toggle('working', isSubmitting);
			button.disabled = isSubmitting;
			if (isSubmitting) {
				button.setAttribute('aria-busy', 'true');
			} else {
				button.removeAttribute('aria-busy');
			}
		}
		_serializeForm(form) {
			let arr = [];
			Array.prototype.slice.call(form.elements).forEach(function(field) {
				if (
					!field.name ||
					field.disabled ||
					['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
				)
					return;
				if (field.type === 'select-multiple') {
					Array.prototype.slice.call(field.options).forEach(function(option) {
						if (!option.selected) return;
						arr.push(
							encodeURIComponent(field.name) +
								'=' +
								encodeURIComponent(option.value)
						);
					});
					return;
				}
				if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
					return;
				arr.push(
					encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
				);
			});
			return arr.join('&');
		}

	}

	if ( typeof customElements.get('product-form') == 'undefined' ) {
		customElements.define('product-form', ProductForm);
	}

}

/* ---
	Product Recommendations
--- */

if ( typeof ProductRecommendations !== 'function' ) {

	class ProductRecommendations extends HTMLElement {
		constructor() {

			super();

			const SUCCESS = new Event('product-recommendations-loaded');
			const FAIL = new Event('product-recommendations-error');

			const handleIntersection = (entries, observer) => {

				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const innerHTML = new DOMParser()
							.parseFromString(text, 'text/html')
							.querySelector('product-recommendations');

						if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
							this.innerHTML = innerHTML.innerHTML;
							this.querySelectorAll('form').forEach(elm=>{
							if (elm.querySelector('template')) {
								elm.append(elm.querySelector('template').content.cloneNode(true));
							}
						});
						this.dispatchEvent(SUCCESS);
					} else {
						this.dispatchEvent(FAIL);
					}
				})
				.catch(e => {
					this.dispatchEvent(FAIL);
				});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this);

		}

	}

	if ( typeof customElements.get('product-recommendations') == 'undefined' ) {
		customElements.define('product-recommendations', ProductRecommendations);
	}

}

/* ---
	Gift card recipent
--- */

if ( typeof GiftCardRecipient !== 'function' ) {

	class GiftCardRecipient extends HTMLElement {

		constructor() {

			super();

			const properties = Array.from(this.querySelectorAll('[name*="properties"]'));
			const checkboxPropertyName = 'properties[__shopify_send_gift_card_to_recipient]';

			this.recipientCheckbox = properties.find(input => input.name === checkboxPropertyName);
			this.recipientOtherProperties = properties.filter(input => input.name !== checkboxPropertyName);
			this.recipientFieldsContainer = this.querySelector('.gift-card-recipient__fields');

			if ( this.recipientCheckbox ) {
				this.recipientCheckbox.addEventListener('change', this.synchronizeProperties.bind(this));
			}
			this.synchronizeProperties();

		}

		synchronizeProperties() {
			this.recipientOtherProperties.forEach(property => property.disabled = !this.recipientCheckbox.checked);
			this.recipientFieldsContainer.classList.toggle('hide', !this.recipientCheckbox.checked);
		}

	}

	if ( typeof customElements.get('gift-card-recipient') == 'undefined' ) {
		customElements.define('gift-card-recipient', GiftCardRecipient);
	}

}
